import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useMemo, useState } from "react";
import { useSecureFetch } from "../../utils/useSecureFetch";
import { useSecureFetch2 } from "../../utils/useSecureFetch2";
import bgSection from "../../assets/img/bgSection.png";
// -----------

export function HeroDefault({ section }) {
  const bgImage =
    `${process.env.REACT_APP_API_BASE_URL_STORAGE}/${section.image}` ||
    `${process.env.REACT_APP_API_BASE_URL_STORAGE}/${section.image_side}` ||
    "";
  return (
    <section
      className="relative bg-white text-white h-[90vh] flex items-center px-6 md:px-12"
      style={{
        backgroundImage: bgImage ? `url(${bgImage})` : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {section.image && <div className="absolute inset-0 bg-black/40 z-0" />}
      <div className="relative bg-black bg-opacity-50 p-6 rounded max-w-xl">
        {section.title && (
          <h1 className="text-4xl font-bold mb-2">{section.title}</h1>
        )}
        {section.subtitle && (
          <h2 className="text-xl mb-4">{section.subtitle}</h2>
        )}
        {section.content && <p className="mb-6">{section.content}</p>}
        {section.button_text && section.button_link && (
          <a
            href={section.button_link}
            className="inline-block bg-orange-600 hover:bg-orange-700 px-6 py-3 rounded font-semibold"
          >
            {section.button_text}
          </a>
        )}
      </div>
    </section>
  );
}
/* 
export function HeroDefault({ section }) {
  const bgImage = section.image_side || section.image || "";

  return (
    <section
      className="relative h-[80vh] flex items-center justify-center px-6 md:px-12"
      style={{
        backgroundImage: bgImage
          ? `linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.45)), url(${bgImage})`
          : "none",
        backgroundSize: "cover",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="bg-black bg-opacity-60 p-8 rounded max-w-3xl text-center text-white drop-shadow-lg">
        {section.title && (
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4 leading-tight">
            {section.title}
          </h1>
        )}
        {section.subtitle && (
          <h2 className="text-xl md:text-2xl mb-6 font-light">
            {section.subtitle}
          </h2>
        )}
        {section.content && (
          <p className="mb-8 text-md md:text-lg leading-relaxed">
            {section.content}
          </p>
        )}
        {section.button_text && section.button_link && (
          <a
            href={section.button_link}
            className="inline-block bg-orange-600 hover:bg-orange-700 transition-colors duration-300 px-8 py-3 rounded font-semibold shadow-lg"
          >
            {section.button_text}
          </a>
        )}
      </div>
    </section>
  );
}
 */
// -----------------------
export function HeroMinimal({ section }) {
  const bgImage = section.image
    ? `${process.env.REACT_APP_API_BASE_URL_STORAGE}/${section.image}`
    : null;

  return (
    <section className="relative w-full text-white h-[60vh] flex items-center justify-center text-center">
      {bgImage ? (
        <div
          className="relative h-[60vh] w-full"
          style={{
            backgroundImage: `url("${bgImage}")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="absolute inset-0 bg-black/40 z-10" />
        </div>
      ) : (
        <div className="min-h-[60vh] w-full bg-orange-900 flex items-center justify-center text-orange-400 text-4xl">
          <i className="fas fa-image"></i>
        </div>
      )}
      {/* Overlay sombre toujours présent */}
      <div className="absolute inset-0 bg-black/60 z-0" />

      {/* Fallback si pas d'image */}
      {/* {!bgImage && (
        <div className="min-h-[60vh] w-full bg-orange-900 flex items-center justify-center text-orange-400 text-4xl">
          <i className="fas fa-image"></i>
        </div>
      )} */}

      {/* Contenu centré */}
      <div className="absolute inset-0 z-20 flex items-center justify-center text-center pointer-events-none">
        <div className="max-w-fit text-white">
          <h2 className="text-4xl font-bold mb-4">{section.title}</h2>
          <h5 className="text-xl mb-4">{section.subtitle}</h5>
          <div className="flex justify-around mt-10">
            {section.button_link && section.button_text && (
              <Link
                to={section.button_link ? "/" + section.button_link : ""}
                className="inline-block bg-[#74BB43] hover:bg-orange-700 px-6 py-3 rounded pointer-events-auto"
              >
                {section.button_text}
              </Link>
            )}
            {/* <Link
              to="/prendre-rdv"
              className="inline-block bg-orange-600 hover:bg-orange-700 px-6 py-3 rounded pointer-events-auto"
            >
              SHOWROOM
            </Link> */}
          </div>
        </div>
      </div>
    </section>
  );
}

// -------------------------
export function HeroSplit({ section }) {
  return (
    <section className="bg-white py-20 px-6 md:px-12">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-10">
        <div className="md:w-1/2 w-full text-gray-900">
          {section.title && (
            <h1 className="text-3xl md:text-5xl font-bold mb-4">
              {section.title}
            </h1>
          )}
          {section.subtitle && (
            <h2 className="text-xl text-orange-400 mb-3 text-gray-600">
              {section.subtitle}
            </h2>
          )}
          {section.content && (
            <p className="text-gray-700 mb-6 leading-relaxed">
              {section.content}
            </p>
          )}
          <div className="flex md:flex-row flex-col gap-3 justify-around mt-10 text-white text-sm">
            <Link
              to={section.button_link ? "/" + section.button_link : ""}
              className="inline-block bg-[#74BB43] hover:bg-orange-700 px-6 py-3 rounded pointer-events-auto"
            >
              {section.button_text}
            </Link>
            <Link
              to="/prendre-rdv"
              className="inline-block bg-orange-600 hover:bg-orange-700 px-6 py-3 rounded pointer-events-auto"
            >
              Reservez votre essai
            </Link>
          </div>
        </div>
        <div className="md:w-1/2 w-full">
          {section.image_side ? (
            <img
              src={`${process.env.REACT_APP_API_BASE_URL_STORAGE}/${section.image_side}`}
              alt={section.title || "Image"}
              className="w-full rounded"
            />
          ) : (
            <div className="min-h-[400px] w-full bg-orange-900 flex items-center justify-center text-orange-400 text-4xl">
              <i className="fas fa-image"></i>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

// ---------------------------------------
export function HeroSplitInverse({ section }) {
  return (
    <section className="bg-white py-20 px-6 md:px-12">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row-reverse items-center gap-10">
        {(section.image || section.image_side) && (
          <div className="md:w-1/2 w-full">
            <img
              src={
                `${process.env.REACT_APP_API_BASE_URL_STORAGE}/${section.image}` ||
                `${process.env.REACT_APP_API_BASE_URL_STORAGE}/${section.image_side}`
              }
              alt={section.title || "hero image"}
              className="w-full h-auto object-cover rounded-xl shadow-lg"
            />
          </div>
        )}
        <div className="md:w-1/2 w-full text-gray-900">
          {section.title && (
            <h1 className="text-3xl md:text-5xl font-bold mb-4">
              {section.title}
            </h1>
          )}
          {section.subtitle && (
            <h2 className="text-xl mb-3 text-gray-600">{section.subtitle}</h2>
          )}
          {section.content && (
            <p className="text-gray-700 mb-6 leading-relaxed">
              {section.content}
            </p>
          )}
          {section.button_text && section.button_link && (
            <a
              href={section.button_link}
              className="inline-block px-6 py-3 bg-orange-600 hover:bg-orange-700 text-white font-semibold rounded shadow transition duration-300"
            >
              {section.button_text}
            </a>
          )}
        </div>
      </div>
    </section>
  );
}

export const HeroRowWithSS = ({ section }) => {
  return (
    <section className="py-20 px-6 md:px-12 bg-white text-center">
      {/* Titre */}
      {section.title && (
        <h1 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">
          {section.title}
        </h1>
      )}

      {/* Contenu */}
      {section.content && (
        <div
          className="max-w-7xl mx-auto text-lg text-gray-700 leading-relaxed text-justify mb-10"
          dangerouslySetInnerHTML={{ __html: section.content }}
        />
      )}

      {/* Image principale */}
      {section.image ? (
        <img
          src={`${process.env.REACT_APP_API_BASE_URL_STORAGE}/${section.image}`}
          alt="Hero"
          className="mx-auto max-w-full h-auto rounded-lg mb-10"
        />
      ) : (
        <div className="min-h-[60vh] max-w-7xl mx-auto bg-orange-900 flex items-center justify-center text-orange-400 text-4xl">
          <i className="fas fa-image"></i>
        </div>
      )}
      <br />

      {/* Image secondaire */}
      {section.image_side ? (
        <img
          src={`${process.env.REACT_APP_API_BASE_URL_STORAGE}/${section.image_side}`}
          alt="Side"
          className="mx-auto max-w-xs h-auto rounded mb-12"
        />
      ) : (
        <div className="min-h-[20vh] max-w-7xl mx-auto bg-orange-900 flex items-center justify-center text-orange-400 text-4xl">
          <i className="fas fa-image"></i>
        </div>
      )}
      <br />

      {/* Sous-sections en cards */}
      {section.subsections?.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {section.subsections.map((ss, index) => (
            <div
              key={index}
              className="rounded-lg p-6 shadow hover:shadow-md transition"
            >
              <h1 className="font-semibold text-[#74BB43] mb-2">
                {ss.subtitle}
              </h1>
              <p className="text-base font-semibold text-gray-700">
                {ss.title}
              </p>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

// HeroCarousel.js

export function HeroCarousel({ section }) {
  const slides = section.subsections || [];

  return (
    <div className="relative text-gray-700 min-h-[80vh] bg-black">
      {/* Superposition du contenu texte */}
      <div className="absolute inset-0 z-20 flex items-center justify-center text-center pointer-events-none">
        <div className="max-w-fit text-white px-12">
          <h2 className="text-4xl font-bold mb-4">{section.title}</h2>
          <h5 className="text-xl mb-4">{section.subtitle}</h5>
          <div className="flex flex-col md:flex-row justify-around gap-3 mt-10">
            <Link
              to={section.button_link ? "/" + section.button_link : ""}
              className="inline-block bg-[#74BB43] hover:bg-[#74BB432B] px-6 py-3 rounded pointer-events-auto transition duration-300"
            >
              {section.button_text}
            </Link>
            <Link
              to="/prendre-rdv"
              className="inline-block bg-orange-500 hover:bg-orange-800 px-6 py-3 rounded pointer-events-auto transition duration-300"
            >
              SHOWROOM
            </Link>
          </div>
        </div>
      </div>

      {/* Carrousel Swiper */}
      <Swiper
        modules={[Navigation]}
        navigation={{
          nextEl: ".swiper-button-next-custom",
          prevEl: ".swiper-button-prev-custom",
        }}
        loop={true}
        className="w-full h-full hero-carousel"
      >
        {slides.map((item, i) => {
          const mediaUrl = item.image
            ? `${process.env.REACT_APP_API_BASE_URL_STORAGE}/${item.image}`
            : "";

          const isVideo = /\.(mp4|webm|ogg)$/i.test(item.image);

          return (
            <SwiperSlide key={i}>
              {mediaUrl ? (
                isVideo ? (
                  <div className="relative h-[90vh] w-full overflow-hidden">
                    <video
                      src={mediaUrl}
                      autoPlay
                      muted
                      loop
                      playsInline
                      className="object-cover w-full h-full"
                    />
                    <div className="absolute inset-0 bg-black/40 z-10" />
                  </div>
                ) : (
                  <div
                    className="relative h-[90vh] w-full"
                    style={{
                      backgroundImage: `url("${mediaUrl}")`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                  >
                    <div className="absolute inset-0 bg-black/40 z-10" />
                  </div>
                )
              ) : (
                <div className="min-h-[90vh] w-full bg-orange-900 flex items-center justify-center text-orange-400 text-4xl">
                  <i className="fas fa-image"></i>
                </div>
              )}
            </SwiperSlide>
          );
        })}
      </Swiper>

      {/* Flèches de navigation personnalisées */}
      <div className="hidden md:block swiper-button-prev-custom absolute border p-3 rounded-full left-4 top-1/2 -translate-y-1/2 z-30 text-white font-bold cursor-pointer select-none">
        Prec
      </div>
      <div className="hidden md:block swiper-button-next-custom absolute border p-3 rounded-full right-4 top-1/2 -translate-y-1/2 z-30 text-white font-bold cursor-pointer select-none">
        Suiv
      </div>
    </div>
  );
}

// HeroInfo.js
export function HeroInfo({ section }) {
  const location = useLocation();
  const accueil = location.pathname === "/accueil";
  return (
    <div
      className="py-16 px-6 md:px-12 bg-white text-black"
      style={{
        backgroundImage: accueil ? `url("${bgSection}")` : "none",
        backgroundSize: "contain",
        backgroundPosition: "right center", // aligné à droite
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Titre centré en haut */}
      {section.title && (
        <h2 className="text-center text-orange-600 uppercase text-3xl font-semibold mb-10 abeezee">
          {section.title}
        </h2>
      )}

      <div className="rounded-xl p-8 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
        {section.image_side ? (
          <img
            src={`${process.env.REACT_APP_API_BASE_URL_STORAGE}/${section.image_side}`}
            alt={section.title || "Image"}
            className="w-full rounded"
          />
        ) : (
          <div className="min-h-[400px] w-full bg-orange-900 flex items-center justify-center text-orange-400 text-4xl">
            <i className="fas fa-image"></i>
          </div>
        )}

        <div>
          {section.subtitle && (
            <h1 className="font-bold mb-4 text-3xl text-gray-900">
              {section.subtitle}
            </h1>
          )}
          {section.content && (
            <div
              className="mb-4 text-gray-700 text-justify"
              dangerouslySetInnerHTML={{ __html: section.content }}
            />
          )}
          <Link
            to={section.button_link ? "/" + section.button_link : ""}
            className="inline-block border-2 border-bg-[#74BB43] text-[#74BB43] hover:bg-[#74BB43] px-6 py-3 rounded pointer-events-auto transition-colors duration-300 hover:text-white"
          >
            {section.button_text}
          </Link>
        </div>
      </div>
    </div>
  );
}

export function HeroInfoInverse({ section }) {
  return (
    <section
      className="py-16 px-6 md:px-12 relative bg-white"
      style={{
        backgroundImage: section.image
          ? `url(${process.env.REACT_APP_API_BASE_URL_STORAGE}/${section.image})`
          : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {section.image && (
        <div className="absolute inset-0 bg-black/40 backdrop-blur-sm z-0" />
      )}
      <div className="rounded-xl p-8 grid grid-cols-1 md:grid-cols-2 gap-8 items-center relative z-10 ">
        <div>
          <p className="mb-2">{section.title}</p>
          {section.subtitle && (
            <h1 className="font-bold mb-2">{section.subtitle}</h1>
          )}
          {section.content && (
            <p className="mb-4 text-gray-700">{section.content}</p>
          )}
          {section.button_text && section.button_link && (
            <a
              href={section.button_link}
              className="inline-block bg-orange-600 hover:bg-orange-700 px-4 py-2 text-white rounded"
            >
              {section.button_text}
            </a>
          )}
          {section.subsections?.length > 0 && (
            <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
              {section.subsections.map((item, index) => (
                <div
                  key={index}
                  className="border p-4 rounded bg-white shadow-sm text-black text-center"
                >
                  <h4 className="text-lg font-semibold">{item.title}</h4>
                  {item.subtitle && (
                    <p className="text-sm text-gray-500">{item.subtitle}</p>
                  )}
                  {item.content && (
                    <p className="mt-2 text-gray-600">{item.content}</p>
                  )}
                  {item.button_text && item.button_link && (
                    <a
                      href={item.button_link}
                      className="inline-block mt-2 text-orange-600 hover:underline"
                    >
                      {item.button_text}
                    </a>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
        {section.image_side && (
          <div>
            <img
              src={`${process.env.REACT_APP_API_BASE_URL_STORAGE}/${section.image_side}`}
              alt={section.title || "Image"}
              className="w-full rounded shadow"
            />
          </div>
        )}
      </div>
    </section>
  );
}

export function HeroVideo({ section }) {
  const bgImage = section.image
    ? `${process.env.REACT_APP_API_BASE_URL_STORAGE}/${section.image}`
    : null;

  const sideMedia = section.image_side
    ? `${process.env.REACT_APP_API_BASE_URL_STORAGE}/${section.image_side}`
    : null;

  const isVideo = sideMedia && sideMedia.endsWith(".mp4");

  return (
    <section className="relative w-full text-white h-[90vh] flex items-center justify-center text-center overflow-hidden">
      {/* Background avec blur si image */}
      {bgImage && (
        <div
          className="absolute inset-0 z-0 blur-sm scale-110"
          style={{
            backgroundImage: `url("${bgImage}")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
      )}
      {/* Overlay sombre */}
      <div className="absolute inset-0 bg-black/60 z-10" />

      {/* Contenu centré */}
      <div className="absolute inset-0 z-20 flex items-center justify-center text-center pointer-events-none">
        <div className="max-w-3xl px-4 text-white pointer-events-auto">
          <h2 className="text-4xl font-bold mb-4">{section.title}</h2>
          <h5 className="text-xl mb-6">{section.subtitle}</h5>

          {/* Image/vidéo secondaire juste sous les titres */}
          {sideMedia && (
            <div className="mb-6 px-4">
              {isVideo ? (
                <video
                  src={sideMedia}
                  className="rounded max-w-full max-h-[200px] mx-auto"
                  autoPlay
                  muted
                  loop
                  playsInline
                />
              ) : (
                <img
                  src={sideMedia}
                  alt="Media secondaire"
                  className="rounded max-w-full max-h-[200px] mx-auto"
                />
              )}
            </div>
          )}

          {/* Bouton d’action */}
          {section.button_link && section.button_text && (
            <div className="mt-4">
              <Link
                to={"/" + section.button_link}
                className="inline-block bg-[#74BB43] hover:bg-orange-700 px-6 py-3 rounded"
              >
                {section.button_text}
              </Link>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export function HeroAds({ section }) {
  const bgImage = section.image
    ? `${process.env.REACT_APP_API_BASE_URL_STORAGE}/${section.image}`
    : null;

  return (
    <div className="relative w-full px-6 md:px-12 py-4">
      {bgImage ? (
        <div
          className="w-full aspect-[16/9] rounded-xl bg-no-repeat bg-center bg-contain"
          style={{
            backgroundImage: `url("${bgImage}")`,
          }}
        ></div>
      ) : (
        <div className="w-full aspect-[16/9] bg-orange-900 rounded-xl flex items-center justify-center text-orange-400 text-4xl">
          <i className="fas fa-image"></i>
        </div>
      )}
    </div>
  );
}

// ----------------------------------
// Ecom Components
// ----------------------------------

// HERO AVEC FILTRES
// export function HeroWithFilters({ section }) {
//   const [filters, setFilters] = useState({
//     type: "",
//     categorie: "",
//     brand: "",
//   });
//   const [produits, setProduits] = useState([]);

//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchProduits = async () => {
//       const res = await fetch(
//         `${process.env.REACT_APP_API_BASE_URL}/produits-public/light`
//       );
//       const data = await res.json();
//       setProduits(data.produits);
//     };
//     fetchProduits();
//   }, []);

//   const types = useMemo(() => {
//     const map = {};
//     produits.forEach((p) => {
//       if (p.type && !map[p.type.id]) {
//         map[p.type.id] = p.type;
//       }
//     });
//     return Object.values(map);
//   }, [produits]);

//   const categories = useMemo(() => {
//     const map = {};
//     produits.forEach((p) => {
//       if (
//         p.categorie &&
//         (!filters.type || p.categorie.type_id === parseInt(filters.type))
//       ) {
//         map[p.categorie.id] = p.categorie;
//       }
//     });
//     return Object.values(map);
//   }, [produits, filters.type]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFilters((prev) => ({ ...prev, [name]: value }));
//   };

//   const goToCatalogue = () => {
//     const query = new URLSearchParams(filters).toString();
//     navigate(`/boutique/catalogue?${query}`);
//   };
//   return (
//     <section
//       className="relative h-[80vh] flex items-center px-6 md:px-12 text-white"
//       style={{
//         backgroundImage: section.image
//           ? `url(${process.env.REACT_APP_API_BASE_URL_STORAGE}/${section.image})`
//           : "none",
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//       }}
//     >
//       <div className="absolute inset-0 bg-black/50 z-0" />
//       <div className="relative z-10 w-full max-w-6xl mx-auto text-center">
//         <h1 className="text-4xl font-bold mb-6">{section.title}</h1>
//         <div className="bg-white/90 rounded-xl p-4 md:p-6 flex flex-wrap gap-4 justify-center items-center shadow-lg w-full mx-auto">
//           <select
//             name="type"
//             onChange={handleChange}
//             value={filters.type}
//             className="py-2 rounded border text-black border-gray-700 px-5 flex-1 min-w-[140px]"
//           >
//             <option value="">Tous les types</option>
//             {types.map((type) => (
//               <option key={type.id} value={type.id}>
//                 {type.libelle}
//               </option>
//             ))}
//           </select>

//           <select
//             name="categorie"
//             onChange={handleChange}
//             value={filters.categorie}
//             className="py-2 rounded border text-black border-gray-700 px-5 flex-1 min-w-[140px]"
//             disabled={!filters.type}
//           >
//             <option value="">Toutes les Catégories</option>
//             {categories.map((cat) => (
//               <option key={cat.id} value={cat.id}>
//                 {cat.nom}
//               </option>
//             ))}
//           </select>

//           <button
//             className="bg-orange-600 text-white px-4 py-2 rounded"
//             onClick={goToCatalogue}
//           >
//             Recherchez
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// }

// AsNumeric
export function HeroWithFilters({ section }) {
  const [filters, setFilters] = useState({
    type_unit: "",
    categorie: "",
    brand: "",
  });

  const [source, setSource] = useState("vehicules"); // "vehicules" ou "pieces"
  const navigate = useNavigate();

  const vehiculesApi = useSecureFetch2("product");
  const piecesApi = useSecureFetch("product");

  const { db, loading } = source === "vehicules" ? vehiculesApi : piecesApi;

  const produits = useMemo(() => db.data || [], [db]);

  const typeUnits = useMemo(() => {
    const set = new Set();
    produits.forEach((p) => {
      if (p.type_unit) set.add(p.type_unit);
    });
    return Array.from(set);
  }, [produits]);

  const categories = useMemo(() => {
    const map = {};
    produits.forEach((p) => {
      if (p.category) {
        map[p.category] = p.category;
      }
    });
    return Object.values(map);
  }, [produits]);

  const produitsFiltres = useMemo(() => {
    return produits.filter((p) => {
      const matchType = !filters.type_unit || p.type_unit === filters.type_unit;
      const matchCat = !filters.categorie || p.category === filters.categorie;
      return matchType && matchCat;
    });
  }, [produits, filters]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const goToCatalogue = () => {
    const query = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value) query.set(key, value);
    });
    query.set("source", source); // pour info dans URL
    navigate(`/boutique/catalogue?${query.toString()}`);
  };

  const capitalize = (text) =>
    text.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());

  const switchSource = (newSource) => {
    setSource(newSource);
    setFilters({ type_unit: "", categorie: "", brand: "" }); // reset filtres
  };

  return (
    <section
      className="relative h-[85vh] flex items-center px-6 md:px-12 text-white"
      style={{
        backgroundImage: section.image
          ? `url(${process.env.REACT_APP_API_BASE_URL_STORAGE}/${section.image})`
          : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-black/50 z-0" />
      <div className="relative z-10 w-full max-w-6xl mx-auto text-center">
        <h1 className="text-4xl font-bold mb-6">{section.title}</h1>

        {/* Bloc filtres */}
        {loading ? (
          <>
            {/* Skeleton pour les onglets */}
            <div className="mb-6 flex justify-center gap-4 animate-pulse">
              <div className="h-10 bg-gray-300 rounded-lg w-[160px]"></div>
              <div className="h-10 bg-gray-300 rounded-lg w-[160px]"></div>
            </div>

            {/* Skeleton pour le bloc filtres */}
            <div className="bg-white/90 rounded-xl p-6 flex flex-wrap gap-4 justify-center items-center shadow-lg w-full mx-auto animate-pulse">
              {/* Type d'unité */}
              <div className="h-10 bg-gray-300 rounded-lg w-[160px]"></div>
              {/* Catégorie */}
              <div className="h-10 bg-gray-300 rounded-lg w-[160px]"></div>
              {/* Texte nombre produits */}
              <div className="h-6 bg-gray-300 rounded-lg w-1/2"></div>
              {/* Bouton rechercher */}
              <div className="h-10 bg-gray-300 rounded-lg w-[130px]"></div>
            </div>
          </>
        ) : (
          <>
            {/* Onglets de sélection */}
            <div className="mb-6 flex justify-center gap-4">
              <button
                onClick={() => switchSource("vehicules")}
                className={`px-4 py-2 rounded-lg transition ${
                  source === "vehicules"
                    ? "bg-orange-600 text-white"
                    : "bg-white text-black border border-gray-300"
                }`}
              >
                Véhicules électriques
              </button>
              <button
                onClick={() => switchSource("pieces")}
                className={`px-4 py-2 rounded-lg transition ${
                  source === "pieces"
                    ? "bg-orange-600 text-white"
                    : "bg-white text-black border border-gray-300"
                }`}
              >
                Pièces & Accessoires
              </button>
            </div>

            {/* Bloc filtres */}
            <div className="bg-white/90 rounded-xl p-6 flex flex-wrap gap-4 justify-center items-center shadow-lg w-full mx-auto">
              <select
                name="type_unit"
                onChange={handleChange}
                value={filters.type_unit}
                className="py-2 rounded-lg border text-black border-gray-300 px-5 min-w-[160px] focus:ring-2 focus:ring-orange-500"
              >
                <option value="">Tous les types</option>
                {typeUnits.map((t, index) => (
                  <option key={index} value={t}>
                    {t}
                  </option>
                ))}
              </select>

              <select
                name="categorie"
                onChange={handleChange}
                value={filters.categorie}
                className="py-2 rounded-lg border text-black border-gray-300 px-5 min-w-[160px] focus:ring-2 focus:ring-orange-500"
              >
                <option value="">Toutes les catégories</option>
                {categories.map((cat, index) => (
                  <option key={index} value={cat}>
                    {capitalize(cat)}
                  </option>
                ))}
              </select>

              <p className="text-black font-semibold w-full text-center">
                {produitsFiltres.length} produit
                {produitsFiltres.length > 1 ? "s" : ""} trouvé
                {produitsFiltres.length > 1 ? "s" : ""}
              </p>

              <button
                className="bg-orange-600 text-white px-4 py-2 rounded-lg hover:bg-orange-700 transition"
                onClick={goToCatalogue}
              >
                Recherchez
              </button>
            </div>
          </>
        )}
      </div>
    </section>
  );
}
